import {
    Box,
    FormControl,
    FormControlLabel,
    RadioGroup,
    Typography,
} from "@mui/material";
import CustomButton from "../../../UIElements/CustomButton";
import CancelModalButton from "../../../UIElements/CustomModal/CancelModalButton";
import { useState } from "react";
import { DossierDataToUpdate } from "../../../../types";
import ReactSvgIcon from "../../../UIElements/ReactSvgIcon";
import { ReactComponent as CircleCheckIcon } from "../../../../public/icons/CircleCheckIcon.svg";
import CustomRadio from "../../../UIElements/CustomRadio";
import { useFetch } from "../../../../hooks";

export default function SendDossierToSynerpaModalContent({
    stepsOk,
    dataDossier,
    onSubmit,
    defaultOpinionValue,
}: {
    stepsOk: boolean;
    dataDossier: DossierDataToUpdate;
    onSubmit: Function;
    defaultOpinionValue: boolean;
}) {
    const { fetcher } = useFetch();
    const textStepsOk = stepsOk
        ? "Tous les documents de ce dossier sont conformes"
        : "un ou plusieurs documents ne sont pas conformes, mais il n'est plus possible de retourner le dossier au client.";
    let iconRes = stepsOk ? (
        <ReactSvgIcon
            width="1.5rem"
            height="1.5rem"
            ReactIcon={CircleCheckIcon}
        />
    ) : (
        <></>
    );
    const [comContent, setComContent] = useState("");
    const [opinion, setOpinion] = useState<boolean>(defaultOpinionValue);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "1.25rem",
                    alignSelf: "stretch",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "1.25rem",
                        alignSelf: "stretch",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "0.5rem",
                            alignSelf: "stretch",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "var(--Generiques-Dark-Blue-1, #023)",
                                fontFamily: "Roboto",
                                fontSize: "1.25rem",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "normal",
                            }}
                        >
                            Soumettre un avis
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "1rem",
                                alignSelf: "stretch",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "var(--Generiques-Dark-Blue-1, #023)",
                                    fontFamily: "Roboto",
                                    fontSize: "0.875rem",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "1.25rem",
                                }}
                            >
                                Votre avis permettra au représentant Synerpa de
                                prendre sa décision lors de la qualification du
                                dossier.
                                <Typography
                                    sx={{
                                        color: "var(--Generiques-Dark-Blue-1, #023)",
                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: "700",
                                        lineHeight: "1.25rem",
                                    }}
                                >
                                    Le dossier ne sera plus modifiable.
                                </Typography>
                            </Typography>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            padding: "1rem",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "0.75rem",
                            alignSelf: "stretch",
                            borderRadius: "0.75rem",
                            border: "1px solid var(--Socotec-Socotec-Dark-Blue, #005499)",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "0.75rem",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                }}
                            >
                                {iconRes}
                                <Typography
                                    sx={{
                                        color: "var(--Socotec-Socotec-Dark-Blue, #005499)",
                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: "500",
                                        lineHeight: "normal",
                                    }}
                                >
                                    {textStepsOk}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "1rem",
                    }}
                >
                    <Typography
                        sx={{
                            color: "var(--Generiques-Dark-Blue-1, #023)",
                            fontFamily: "Roboto",
                            fontSize: "1rem",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "normal",
                        }}
                    >
                        <b>{"Donner un avis"}</b>
                    </Typography>
                    <FormControl>
                        <RadioGroup
                            value={opinion}
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            onChange={(e) => {
                                const value =
                                    e.target.value === "true"
                                        ? true
                                        : e.target.value === "false"
                                        ? false
                                        : false;
                                setOpinion(value);
                            }}
                        >
                            <FormControlLabel
                                value={true}
                                control={<CustomRadio />}
                                label={"Favorable"}
                            />
                            <FormControlLabel
                                value={false}
                                control={<CustomRadio />}
                                label={"Défavorable"}
                            />
                        </RadioGroup>
                    </FormControl>
                </Box>

                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        display: "inline-flex",
                    }}
                >
                    <div
                        style={{
                            alignSelf: "stretch",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            gap: 4,
                            display: "inline-flex",
                        }}
                    >
                        <div
                            style={{
                                color: "#002233",
                                fontSize: "0.875rem",
                                fontFamily: "Roboto",
                                fontWeight: "500",
                                lineHeight: "1.4rem",
                                wordWrap: "break-word",
                            }}
                        >
                            Commentaire global
                        </div>
                        <div
                            style={{
                                flex: "1 1 0",
                                color: "#002233",
                                fontSize: "0.875rem",
                                fontFamily: "Roboto",
                                fontStyle: "italic",
                                fontWeight: "400",
                                lineHeight: "1.365rem",
                                wordWrap: "break-word",
                            }}
                        >
                            (Facultatif)
                        </div>
                    </div>
                    <div
                        style={{
                            color: "#002233",
                            fontSize: "0.75rem",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                            lineHeight: "0.975rem",
                            wordWrap: "break-word",
                        }}
                    >
                        Visible uniquement par le SYNERPA
                    </div>
                </div>
                <div
                    style={{
                        width: "94%",
                        height: "100%",
                        padding: "1.0625rem 1rem",
                        background: "white",
                        borderRadius: "1rem",
                        border: "2px #E3E6E8 solid",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "0.5rem",
                        display: "inline-flex",
                    }}
                >
                    <textarea
                        value={comContent}
                        onChange={(e) => setComContent(e.target.value)}
                        name="comment"
                        style={{
                            resize: "none",
                            flex: "1 1 0",
                            color: "#002233",
                            fontSize: "1rem",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                            fontStyle: "normal",
                            lineHeight: "1.6rem",
                            wordWrap: "break-word",
                            border: "none",
                            outline: "none",
                        }}
                    ></textarea>
                </div>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "1rem",
                    alignSelf: "stretch",
                }}
            >
                <CustomButton
                    onClick={async () => {
                        const comment = document.querySelector(
                            "textarea[name='comment']"
                        );
                        if (comment) {
                            dataDossier.assignedComment = comContent;
                        }
                        dataDossier.assignedUserOpinion = opinion;
                        fetcher(onSubmit(dataDossier));
                    }}
                    label="Validez l'avis"
                    customsx={{
                        width: "100%",
                    }}
                />
                <CancelModalButton
                    customsx={{
                        width: "100%",
                    }}
                />
            </Box>
        </Box>
    );
}
